import React from 'react';
import './LoadingButton.scss';

function LoadingButton({ className = '' }) {
    return (
        <button 
            className={`custom-button loading-button disabled ${className}`}
            disabled={true}
        >
            <div className="spinner"></div>
        </button>
    );
}

export default LoadingButton;

